import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import s from '@styles/vrste-transporta.module.css';

const VrsteTransporta = () => (
  <StaticQuery
    query={graphql`
      query {
        silo: file(relativePath: { eq: "transport/silo-transport.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 600, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        kiper: file(relativePath: { eq: "transport/transport-kiper.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 600, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <section className={s.vrsteTransportaSection}>
        <div className="container">
          <div className="section-header">
            <h2>Vrste transporta</h2>
          </div>
          <div className="row justify-center">
            <div className="col-md-6 col-lg-5">
              <div className={s.card}>
                <Img
                  fluid={data.silo.childImageSharp.fluid}
                  alt="Silo transport slika"
                />
                <div className={s.textContainer}>
                  <h3>Silo transport</h3>
                  <p>Vršimo usluge prevoza svih praškastih materijala.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-5">
              <div className={s.card}>
                <Img
                  fluid={data.kiper.childImageSharp.fluid}
                  alt="Transport kiperima i sanducarima slika"
                />
                <div className={s.textContainer}>
                  <h3>Transport kiperima</h3>
                  <p>Mogućnost prevoza svih rasutih tereta.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )}
  />
);

export default VrsteTransporta;
